module.exports = __webpack_public_path__ + "static/messages_tennis-ab1530a0e0b931aa5926cec614b090c9.mp4";